import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea7ad4f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column font-medium" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "" }, "絞り込み条件設定", -1))
const _hoisted_3 = {
  class: "overflow-scroll pb-3 px-3",
  style: { maxHeight: '60vh' }
}
const _hoisted_4 = { class: "text-sm font-medium text-black" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"1.5px"},
  class: "surface-200 my-2 mx-1"
}, null, -1))
const _hoisted_6 = { class: "w-full text-black flex flex-wrap" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "line-height-2 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "pi pi-times-circle text-xs font-medium absolute right-0 my-0 mr-2"
}

import { computed, ref, watch } from "vue";
import { PIN_TYPE, TAG_TYPE } from "@/clinic/typings/constants/service_tag";


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogFilterMenus',
  props: {
    serviceTags: null,
    filterTagIds: null,
    visible: { type: Boolean }
  },
  emits: ["filter"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  serviceTags: [];
  filterTagIds: number[];
  visible: boolean;
};





const visible = ref(false);
const filteredTagIds = ref<number[]>([]);

const combinedData = computed(() => [
  {
    label: "カテゴリで絞り込む",
    tags: props.serviceTags.filter(tag => tag.selected_type === TAG_TYPE.single.value),
    bgColor: "#d0cece",
  },
  {
    label: "メニューで絞り込む",
    tags: props.serviceTags.filter(tag => tag.selected_type === TAG_TYPE.multiple.value),
    bgColor: "#9bfadd",
  },
]);

const formattedTagName = (tag: any) => {
  if (tag.pin == PIN_TYPE.pinned || tag.name.length <= 4) return tag.name;

  const nameLength = tag.name.length;
  const splitIndex = Math.ceil(nameLength / 2);

  return `${tag.name.substr(0, splitIndex)}\n${tag.name.substr(splitIndex)}`;
};

const onToggleDialog = () => (visible.value = !visible.value);

const onFilter = () => emits("filter", filteredTagIds.value);

const onUnSelectAll = () => (filteredTagIds.value = []);

const onSelectTag = (id: number) => {
  if (filteredTagIds.value.includes(id)) {
    filteredTagIds.value = filteredTagIds.value.filter(tagId => tagId !== id);
  } else {
    filteredTagIds.value.push(id);
  }
};

watch(
  () => props.visible,
  () => {
    filteredTagIds.value = props.filterTagIds;
    onToggleDialog();
  }
);
watch(
  () => filteredTagIds.value,
  () => onFilter()
);

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: "",
    appendTo: "self",
    contentClass: "p-0 border-round-md",
    class: "w-full mx-3 px-0 dialog-note border-0",
    visible: visible.value,
    closable: false,
    showHeader: false,
    draggable: false,
    "onUpdate:visible": onToggleDialog
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "flex justify-content-center align-items-center relative" }, [
          _hoisted_2,
          _createElementVNode("i", {
            class: "pi pi-times font-bold absolute right-0 top-0 p-3 border-cirlce",
            onClick: onToggleDialog
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(combinedData), (data, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mb-3"
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(data.label), 1),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.id,
                    class: "w-4 p-1"
                  }, [
                    _createElementVNode("div", {
                      class: "w-full pl-3 pr-3 flex text-center align-items-center justify-content-center border-round-lg gap-1 py-1 text-xs font-medium relative shadow-1",
                      style: _normalizeStyle({
                  whiteSpace: 'pre-line',
                  minHeight: '2.25rem',
                  backgroundColor: data.bgColor,
                }),
                      onClick: ($event: any) => (onSelectTag(tag.id))
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(formattedTagName(tag)), 1),
                      (filteredTagIds.value.includes(tag.id))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 12, _hoisted_7)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", { class: "py-4 px-3 flex justify-content-center" }, [
          _createElementVNode("div", { class: "px-1 w-4" }, [
            _createElementVNode("button", {
              class: "w-full font-bold text-black bg-white border-1 border-600 border-round-lg py-3",
              onClick: onUnSelectAll
            }, " 選択解除 ")
          ]),
          _createElementVNode("div", { class: "px-1 flex-grow-1" }, [
            _createElementVNode("button", {
              class: "w-full border-none text-white font-bold border-round-lg py-3",
              style: {"background-color":"#00ca8f"},
              onClick: onToggleDialog
            }, " 選択した条件で検索 ")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})